module.exports = __webpack_public_path__ + "media/images/game/pages/goal-competition-d3ab4dbcb1474e5fe1ad369961839724.png";